import React from 'react';
import PropTypes from 'prop-types';
import './img-navigation-bar.scss';
import classNames from 'classnames';

const ImgNavigationBar = ({
  items,
  className,
}) => (
  <nav className={classNames('img-nav-bar', className)}>
    <ul className="img-nav-bar__list">
      {items.map(item => (
        <li className="img-nav-bar__list-item" key={item.href}>
          <a className="img-nav-bar__link" href={item.href} target="_blank" rel="noopener noreferrer">
            <img className="img-nav-bar__img" src={item.img} alt="Social logo" />
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

ImgNavigationBar.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    img: PropTypes.string,
  })).isRequired,
};

ImgNavigationBar.defaultProps = {
  className: undefined,
};

export default ImgNavigationBar;
